import Index from '@tunnel-components/@pages/supervision/incident/home/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/incident/home/index.ts